import React, {forwardRef, useEffect, useState} from "react";
import classnames from "classnames";
import {TrackClick} from "@/analytics";
import {matchPath, NavLink, useLocation, useMatch} from "react-router-dom";
import "./DashboardNavItem.scss";
import { OptionalTrackClickHOC } from "@/components/OptionalTrackClickHOC";

type DashboardNavItemProps = {
    disabled?: boolean;
    showBottomBorder?: boolean;
    icon?: React.ReactNode;
    children?: React.ReactNode;
    content?: React.ReactNode;
    url: string;
    otherUrls?: string[];
    type?: string;
    onClick?: (e: React.MouseEvent) => void;
    subItems?: DashboardNavItemProps[];
    className?: string;
    title?: string;
    collapsed?: boolean;
    isHeader?: boolean;
    toggleFromParent?: boolean;
    toggleParentMenu?: () => void;
    shouldTrackClick?: boolean;
    trackClickData?: any;
    trackClickName?: string;
}

export const DashboardNavItem = forwardRef<any, DashboardNavItemProps>(( // todo: define a type for the ref
    {
        disabled = false,
        showBottomBorder,
        icon,
        children,
        content = children,
        url,
        otherUrls = [],
        type,
        onClick,
        subItems,
        className,
        title,
        collapsed,
        isHeader = false,
        toggleFromParent = false,
        toggleParentMenu,
        shouldTrackClick,
        trackClickData,
        trackClickName,
        ...props
    },
    ref
) => {
    const baseClassName = "dashboard-nav-item";
    const [active, setActive] = useState(false);
    const {pathname} = useLocation();
    const paths = [url, ...otherUrls].filter(url => url !== undefined);

    useEffect(() => {
        if (!pathname) return;
        const pathnameMatches =
            paths?.filter((pathToCheck) => pathname.search(pathToCheck) > -1)
                ?.length > 0;
        setActive(pathnameMatches);
    }, [pathname]);

    const handleClick = (e) => {
        if (disabled) e.preventDefault() // prevent navigation if disabled
    }

    return (
        <OptionalTrackClickHOC shouldTrackClick={shouldTrackClick} trackClickName={trackClickName} trackClickData={{...trackClickData, previousName: `${content} dashboard nav item clicked`}}>
            <NavLink 
                to={url}
                ref={ref}
                className={classnames(
                    baseClassName, 
                    className, 
                    `${baseClassName}--${type}`, 
                    {
                        [`${baseClassName}--active`]: active,
                        [`${baseClassName}--collapsed`]: collapsed,
                        [`${baseClassName}--expanded`]: !collapsed,
                        [`${baseClassName}--disabled`]: disabled,
                        [`${baseClassName}--showBottomBorder`]: showBottomBorder,
                    }
                )}
                {...props}
            >
                <div className={`${baseClassName}__text`}>
                    {content}
                </div>
            </NavLink>
        </OptionalTrackClickHOC>
    )
});
